import { Button, IconButton, SxProps } from "@mui/material";
import { FC } from "react";

type ResponsiveButtonProps = {
  icon: React.ReactNode;
  onClick: () => void;
  variant?: "text" | "contained" | "outlined";
  color?:
    | "primary"
    | "inherit"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  children?: React.ReactNode;
  sx?: SxProps;
};

export const ResponsiveButton: FC<ResponsiveButtonProps> = ({
  icon,
  onClick,
  children,
  color = "primary",
  variant = "contained",
  sx = {},
}) => {
  return (
    <>
      <Button
        variant={variant as any}
        color={color}
        onClick={onClick}
        startIcon={icon}
        sx={{ display: { xs: "none", sm: "flex" }, ...sx }}
      >
        {children}
      </Button>
      <IconButton
        color={color}
        onClick={onClick}
        sx={{
          display: { xs: "block", sm: "none" },
          bgcolor: variant === "outlined" ? "transparent" : "primary.main",
          color: variant === "outlined" ? "primary.main" : "white",
          border: variant === "outlined" ? "1px solid" : "none",
          borderColor: variant === "outlined" ? "primary.main" : "transparent",
          width: 40,
          height: 40,
          ":hover": {
            bgcolor: variant === "outlined" ? "primary.light" : "primary.dark",
            borderColor:
              variant === "outlined" ? "primary.dark" : "transparent",
          },
          ...sx,
        }}
      >
        {icon}
      </IconButton>
    </>
  );
};
